// extracted by mini-css-extract-plugin
export default {"wrap":"App_wrap__GzNCU"};